// Registro de locales por sección.

export const DEFAULT_LOCALE = "es";

export const LOCALES = {
  es: {
    code: "es",
    htmlLang: "es",
    ogLocale: "es_LA",
    inLanguage: "es",
    geo: null,
    hreflang: null,
    seo: null,
    publishingPrinciples: null,
    descriptions: {
      recetas:
        "Encontrá en Clarín recetas fáciles, prácticas y originales para preparar los platos más ricos. Buscá recetas de entradas, platos principales, postres, pastelería, salsas y aderezos, bebidas y mucho más.",
      default: (sectionName) =>
        `Las noticias más importantes de ${sectionName}. Leé las Noticias de Hoy en Clarín. Conocé las Últimas noticias de Argentina y del mundo, información actualizada las 24 horas y en español`,
    },
  },
  "en-US": {
    code: "en-US",
    htmlLang: "en-US",
    ogLocale: "en_US",
    inLanguage: "en-US",
    geo: { region: "US", country: "US" },
    // hreflang: { lang: "en-us", landingUrl: "https://www.clarin.com/us-news" },
    hreflanges: { lang: "es-AR", landingUrl: "https://www.clarin.com/estados-unidos"},
    seo: {
      title:
        "Breaking news from the US, latest news and top stories on the world and Argentina.",
      description:
        "Latest breaking news, live coverage, and top stories from the U.S. and around the world. Stay updated on entertainment, technology, sports, climate, science, health, lifestyle, and more.",
    },
    publishingPrinciples: "https://www.clarin.com/us-news/editorial-principles",
  },
};

// Locale que hereda todos los valores de "es" y solo agrega su hreflang.
LOCALES["es-us"] = {
  ...LOCALES.es,
  code: "es-us",
  hreflang: { lang: "en-us", landingUrl: "https://www.clarin.com/us-news" },
};

// Mapeo prefijo de URL -> locale. El orden importa (gana el primer match).
export const SECTION_LOCALES = [
  { prefix: "us-news", locale: "en-US" },
  { prefix: "estados-unidos", locale: "es-us" },
];

const normalizePath = (input) => {
  if (!input || typeof input !== "string") return "";
  let path = input;
  if (path.startsWith("http")) {
    try {
      path = new URL(path).pathname;
    } catch (e) {
    }
  }
  return path.replace(/^\/+/, "").split("?")[0].toLowerCase();
};

// Devuelve el código de locale para una URL/sección.
export const getLocaleCode = (input) => {
  const path = normalizePath(input);
  const match = SECTION_LOCALES.find(
    ({ prefix }) => path === prefix || path.startsWith(prefix + "/")
  );
  return match ? match.locale : DEFAULT_LOCALE;
};

// Devuelve la configuración de locale para una URL/sección.
// Acepta varios inputs (ej. url y sectionUrl): usa el primero que resuelva a un locale distinto del default.
export const getLocale = (...inputs) => {
  for (const input of inputs) {
    const code = getLocaleCode(input);
    if (code !== DEFAULT_LOCALE) return LOCALES[code];
  }
  return LOCALES[DEFAULT_LOCALE];
};
